module.exports = __webpack_public_path__ + "img/mx.0a25637b.png";